import { create } from "zustand"

type StyleTemplateChatStore = {
  enableAgent: boolean
  enableWebSearch: boolean
  enableM365: boolean
  enableServiceDesk: boolean
  enableNetbox: boolean
  enableHighReasoning: boolean
  hasInitializedDefaults: boolean
  setEnableAgent: (enabled: boolean) => void
  setEnableWebSearch: (enabled: boolean) => void
  setEnableM365: (enabled: boolean) => void
  setEnableServiceDesk: (enabled: boolean) => void
  setEnableNetbox: (enabled: boolean) => void
  setEnableHighReasoning: (enabled: boolean) => void
  setHasInitializedDefaults: (initialized: boolean) => void
  reset: (defaults?: {
    enableWebSearch?: boolean
    enableM365?: boolean
    enableServiceDesk?: boolean
    enableNetbox?: boolean
  }) => void
}

const initialState = {
  enableAgent: false,
  enableWebSearch: false,
  enableM365: false,
  enableServiceDesk: false,
  enableNetbox: false,
  enableHighReasoning: false,
  hasInitializedDefaults: false,
}

export const useStyleTemplateChatStore = create<StyleTemplateChatStore>((set) => ({
  ...initialState,
  setEnableAgent: (enableAgent) => set({ enableAgent }),
  setEnableWebSearch: (enableWebSearch) => set({ enableWebSearch }),
  setEnableM365: (enableM365) => set({ enableM365 }),
  setEnableServiceDesk: (enableServiceDesk) => set({ enableServiceDesk }),
  setEnableNetbox: (enableNetbox) => set({ enableNetbox }),
  setEnableHighReasoning: (enableHighReasoning) => set({ enableHighReasoning }),
  setHasInitializedDefaults: (hasInitializedDefaults) => set({ hasInitializedDefaults }),
  reset: (defaults) =>
    set({
      ...initialState,
      enableWebSearch: defaults?.enableWebSearch ?? false,
      enableM365: defaults?.enableM365 ?? false,
      enableServiceDesk: defaults?.enableServiceDesk ?? false,
      enableNetbox: defaults?.enableNetbox ?? false,
    }),
}))
